module.exports = __webpack_public_path__ + "static/supplement_facts-1aa06b3a567d42ee82769c93b027e7ee.png";